import React from "react";
import styled, { keyframes } from "styled-components";

const ParticleBackground: React.FC = () => {
  return (
    <ParticleWrapper>
      <div className="orb orb-1" />
      <div className="orb orb-2" />
      <div className="orb orb-3" />
      <div className="grid-overlay" />
    </ParticleWrapper>
  );
};

const float1 = keyframes`
  0%, 100% { transform: translate(0, 0) scale(1); }
  25% { transform: translate(80px, -60px) scale(1.05); }
  50% { transform: translate(-40px, 40px) scale(0.95); }
  75% { transform: translate(60px, 20px) scale(1.02); }
`;

const float2 = keyframes`
  0%, 100% { transform: translate(0, 0) scale(1); }
  25% { transform: translate(-60px, 40px) scale(0.98); }
  50% { transform: translate(50px, -50px) scale(1.04); }
  75% { transform: translate(-30px, -20px) scale(1); }
`;

const float3 = keyframes`
  0%, 100% { transform: translate(0, 0) scale(1); }
  33% { transform: translate(40px, 60px) scale(1.03); }
  66% { transform: translate(-50px, -30px) scale(0.97); }
`;

const ParticleWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  z-index: 0;

  .orb {
    position: absolute;
    border-radius: 50%;
    filter: blur(80px);
    opacity: 0.35;
  }

  .orb-1 {
    width: 500px;
    height: 500px;
    background: radial-gradient(
      circle,
      var(--primary-color) 0%,
      transparent 70%
    );
    top: -10%;
    right: -5%;
    animation: ${float1} 25s ease-in-out infinite;
  }

  .orb-2 {
    width: 400px;
    height: 400px;
    background: radial-gradient(
      circle,
      var(--primary-color-light) 0%,
      transparent 70%
    );
    bottom: -15%;
    left: -5%;
    animation: ${float2} 30s ease-in-out infinite;
  }

  .orb-3 {
    width: 300px;
    height: 300px;
    background: radial-gradient(circle, #a78bfa 0%, transparent 70%);
    top: 40%;
    left: 40%;
    animation: ${float3} 20s ease-in-out infinite;
  }

  .grid-overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-image:
      linear-gradient(var(--border-color) 1px, transparent 1px),
      linear-gradient(90deg, var(--border-color) 1px, transparent 1px);
    background-size: 60px 60px;
    opacity: 0.15;
  }
`;

export default ParticleBackground;
